import type { ComponentProps, ReactNode } from 'react';
import { FieldInfo, useFieldContext } from './shared';
import { Label } from '../label';
import { Switch } from '../switch';
import { cn } from '../../lib/utils';

export default function SwitchField({
	label,
	description,
	className,
	size,
	variant,
	...props
}: ComponentProps<'button'> & { label?: ReactNode; description?: ReactNode; size?: 'lg'; variant?: 'primary' }) {
	const field = useFieldContext<boolean>();

	return (
		<div>
			<div className={cn('text-muted-foreground flex items-start gap-4', className)}>
				<Switch
					id={field.name}
					name={field.name}
					checked={field.state.value}
					onBlur={field.handleBlur}
					onCheckedChange={field.handleChange}
					size={size}
					variant={variant}
					{...props}
				/>
				{(label || description) && (
					<div className="flex flex-col gap-0.5">
						{label && (
							<Label
								data-slot="form-label"
								data-error={field.state.meta.isTouched && !field.state.meta.isValid}
								className={cn('data-[error=true]:text-destructive leading-tight', size === 'lg' && 'text-lg')}
								htmlFor={field.name}
							>
								{label}
							</Label>
						)}
						{description && <p className="text-muted-foreground text-xs leading-snug">{description}</p>}
					</div>
				)}
			</div>
			<FieldInfo fieldState={field.state} />
		</div>
	);
}
